"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var theme = {
  toneValueHover: 0.08,
  toneValueActive: 0.12,
  toneValueFocus: 0.48,
  toneValueOverlay: 0.72,
  colorBgSidebar: {
    normal: "transparent",
    hover: "rgba(255, 255, 255, 0.12)",
    active: "rgba(255, 255, 255, 0.24)"
  },
  colorBgToolbar: {
    normal: "#000000",
    hover: "#1F1F1F",
    active: "#3D3D3D"
  },
  colorBorder: {
    normal: "rgba(255, 255, 255, 0.2)",
    hover: "rgba(255, 255, 255, 0.32)",
    active: "rgba(255, 255, 255, 0.48)",
    focus: "rgba(255, 255, 255, 0.48)"
  },
  depthSidebar: "none",
  depth3: "0 4px 32px 0 rgba(0, 0, 0, 0.48)",
  depth2: "0 4px 48px 0 rgba(0, 0, 0, 0.72)",
  depth1: "0 2px 0 0 rgba(0, 0, 0, 0.04)",
  depth0: "none",
  depthInset: "inset 0 2px 0 0 rgba(0, 0, 0, 0.04)",
  colorBgTint: "transparent",
  colorBgGradientTint: "transparent",
  colorStateHover: {
    normal: "rgba(255, 255, 255, 0.08)"
  },
  colorStateActive: {
    normal: "rgba(255, 255, 255, 0.12)"
  },
  colorOverlay: {
    normal: "rgba(0, 0, 0, 0.72)"
  },
  colorState: {
    normal: "#FFFFFF"
  },
  colorLink: {
    normal: "#589BFF"
  },
  colorLinkVisited: {
    normal: "#6492DA"
  },
  colorIconFavorite: {
    normal: "#FC2C38",
    hover: "#FC3D48",
    active: "#FC4550"
  },
  colorIconUnread: {
    normal: "#0C7CFF",
    hover: "#1F86FF",
    active: "#298CFF"
  },
  colorText: {
    normal: "#D7D7D7"
  },
  colorTextSecondary: {
    normal: "#7B7B7B"
  },
  colorTextAccent: {
    normal: "#ffffff"
  },
  colorTextSidebar: {
    normal: "#FFFFFF"
  },
  colorIcon: {
    normal: "#D7D7D7"
  },
  colorIconSecondary: {
    normal: "#707070",
    hover: "#7B7B7B",
    active: "#818181"
  },
  colorIconAccent: {
    normal: "#ffffff"
  },
  colorIconSidebar: {
    normal: "#FFFFFF"
  },
  colorBorderSidebar: {
    normal: "rgba(255, 255, 255, 0.12)"
  },
  colorScrollbar: {
    normal: "#707070"
  },
  colorBgPlaceholder: {
    normal: "#000000"
  },
  colorDivider: {
    normal: "rgba(0, 0, 0, 0.4)"
  },
  colorPrimary: {
    normal: "#0C7CFF",
    hover: "#1F86FF",
    active: "#298CFF"
  },
  colorBg: {
    normal: "#1F1F1F",
    hover: "#313131",
    active: "#3A3A3A"
  },
  colorBgHighlight: {
    normal: "#6C4E00"
  },
  colorBgPopup: {
    normal: "#313131",
    hover: "#414141",
    active: "#4A4A4A"
  },
  colorBgSecondary: {
    normal: "rgba(255, 255, 255, 0.08)",
    hover: "rgba(255, 255, 255, 0.16)",
    active: "rgba(255, 255, 255, 0.2)"
  },
  colorBgSecondaryFlat: {
    normal: "#313131",
    hover: "#414141",
    active: "#4A4A4A"
  },
  colorBgThumbnail: {
    normal: "#1F1F1F",
    hover: "#313131",
    active: "#3A3A3A"
  },
  colorCategoryMailings: {
    normal: "#FF9C37",
    hover: "#FFA447",
    active: "#FFA84F"
  },
  colorCategorySocial: {
    normal: "#7288FF",
    hover: "#7D92FF",
    active: "#8396FF"
  },
  colorCategoryShopping: {
    normal: "#F94CA3",
    hover: "#F95AAA",
    active: "#FA61AE"
  },
  colorCategoryRegistrations: {
    normal: "#EEAC2C",
    hover: "#EFB33D",
    active: "#F0B645"
  },
  colorCategoryFinance: {
    normal: "#24C780",
    hover: "#36CB8A",
    active: "#3ECE8F"
  },
  colorCategoryTicket: {
    normal: "#3BBAFE",
    hover: "#4BC0FE",
    active: "#53C2FE"
  },
  colorCategoryTravel: {
    normal: "#C15DF3",
    hover: "#C66AF4",
    active: "#C870F4"
  },
  colorCategoryFees: {
    normal: "#EE3C3C",
    hover: "#EF4C4C",
    active: "#F05353"
  }
};
exports.default = theme;